{
  "title": {
    "create": "Créer un terrain",
    "edit": "Modifier le terrain"
  },
  "name": "Nom",
  "bounds": "limites",
  "tiles": "Carreaux",
  "remove_tiles": "Supprimer les carreaux",
  "Pending": "En attente",
  "Active": "Actif",
  "Deleted": "Supprimé",
  "terrain_options": "Cliquez pour ouvrir les options de terrain",
  "edit": "Modifier le terrain",
  "delete": "Supprimer le terrain",
  "uploading_tiles": "Téléchargement de vignettes"
}